import { useAnswerAdd } from "hooks/asocijator/answer/useAnswerAdd";
import { useTopicRelateAnswer } from "../../../provider/TopicRelateAnswer";
import { CharacterResult } from "common/character/dto/CharacterResult";
import { checkAnswerCorrect } from "../RelateAnswerAction.logic";
import { RelateAnswerPayload } from "../RelateAnswerAction.type";
import toast from "react-hot-toast";
import { QUERY_KEYS } from "constant/react_query";

type UseRelateAnswerActionParams = {
  correctAnswerHandle?: () => void;
};

export function useCorrectAnswerByLetter(letter: string): RelateAnswerPayload {
  const { selector } = useTopicRelateAnswer();
  const character: CharacterResult | null = selector.byLetter(letter);
  let answer: RelateAnswerPayload = {
    pronounce: "",
    meaning: "",
    contain: [],
  };
  if (character) {
    answer = characterCorrectAnswerGet(character);
  }

  return answer;
}

const characterCorrectAnswerGet = (
  character: CharacterResult
): RelateAnswerPayload => ({
  pronounce: character.pronounce,
  meaning: character.meaning,
  contain: character.relate?.contain ?? [],
});

export function useRelateAnswerAction({
  correctAnswerHandle,
}: UseRelateAnswerActionParams) {
  const { answerAddMutate } = useAnswerAdd({
    successHandle: (id: any) => {},
    invalidateKeys: [QUERY_KEYS.ASOCIJATOR_TOPIC_STATISTIC],
  });
  const { selector, action } = useTopicRelateAnswer();

  const relateAnswerCheckSend = (
    letter: string,
    answer: RelateAnswerPayload
  ): boolean => {
    const character: CharacterResult | null = selector.byLetter(letter);
    let correct: boolean = false;

    if (character) {
      const answerCorrect = characterCorrectAnswerGet(character);
      correct = checkAnswerCorrect(answerCorrect, answer);
    }

    if (character) {
      action.answerSet(letter, correct);
      if (correct) {
        answerAddMutate({
          characterId: character.id,
          correct: "y",
        });
        toast.success("Correct answer");
        if (correctAnswerHandle) {
          correctAnswerHandle();
        }
      }
    }

    return correct;
  };

  const relateAnswerCorrectSend = (letter: string) => {
    const character: CharacterResult | null = selector.byLetter(letter);

    if (character) {
      const correct: boolean = true;
      action.answerSet(letter, correct);
      if (correct) {
        answerAddMutate({
          characterId: character.id,
          correct: "y",
        });
        toast.success("Correct answer set");
        if (correctAnswerHandle) {
          correctAnswerHandle();
        }
      }
    }
  };

  return { relateAnswerCheckSend, relateAnswerCorrectSend };
}
